// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__XMxVz","vLegacy":"SelectSecondary_vLegacy__M8p9n","error":"SelectSecondary_error__2u8hz","disabled":"SelectSecondary_disabled__OM7_Y"};